<template>
  <div>
    <NavBar />
    <div class="pricing-view-container">
      <h2 class="pricing-header">
        1-on-1 Advising: Genius at your Doorstep
      </h2>
      <div class="how-it-works">
        <div class="left-image">
          <img src="@/assets/images/pricing_1.png" alt="How it works screenshot" />
        </div>
        <div class="right-content">
          <div class="pricing-section">
            <div class="pricing-card">
              <div class="card-header-strip top50-strip"></div>
              <h2>
                <div class="card-title">Top 50 University</div>
                <div class="price">$35/h</div>
              </h2>
              <ul>
                <li>Students attended top 50 universities</li>
                <li>Vetted and trained to offer experienced-based tips and tricks over video calls</li>
                <li>24/7 availability</li>
              </ul>
              <a href="tel:18443436272" class="hero-submit phone__link top-university-price-consult">Schedule a Free Consultation</a>
            </div>

            <div class="pricing-card">
              <div class="card-header-strip ivy-strip"></div>
              <h2>
                <div class="card-title">Ivy League</div>
                <div class="price">$55/h</div>
              </h2>
              <ul>
                <li>Elite Advising from students attending Ivy League</li>
                <li>Top 3% talent</li>
                <li>2+ years of experience</li>
                <li>24/7 availability</li>
              </ul>
              <a href="tel:18443436272" class="hero-submit phone__link ivy-league-price-consult">Schedule a Free Consultation</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom pricing breakdown section -->
      <div class="pricing-summary">
        <div class="pricing-summary-header">
          <div class="summary-content">
            <div class="summary-text">
              <h2>How Much for Tutoring</h2>
              <h2>Tutors on College Genius cost $35–60 per hour on average</h2>
            </div>
            <div class="summary-chart">
              <img src="@/assets/images/pricing_chart.png" alt="Pricing distribution chart" />
            </div>
          </div>
        </div>

        <div class="pricing-summary-features">
          <div class="feature-card">
            <img src="@/assets/images/pricing_icon1.png" alt="Choose your tutor icon" />
            <h3>Choose Your Tutor</h3>
            <p>Compare tutor costs. With a range of price options, there’s a tutor for every budget.</p>
          </div>
          <div class="feature-card">
            <img src="@/assets/images/pricing_icon2.png" alt="No upfront fees icon" />
            <h3>No Upfront Fees</h3>
            <p>Sign up, search, and message with expert tutors free of charge.</p>
          </div>
          <div class="feature-card">
            <img src="@/assets/images/pricing_icon3.png" alt="No costly packages icon" />
            <h3>No Costly Packages</h3>
            <p>Only pay for the time you need. Whether it’s one lesson or several, you decide what to spend.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- NEW CREDIT BUNDLE SECTION -->
    <div class="credit-bundles-section">
      <h2 class="bundles-header">
        Prepaid Credit Bundles: Save More, Study More
      </h2>
      <div class="bundles-full-content">
        <div class="pricing-section">
          <div class="pricing-card">
            <div class="card-header-strip bundle5-strip"></div>
            <h2>
              <div class="card-title">5 Hour Bundle</div>
              <div class="price">$160</div>
            </h2>
            <ul>
              <li>5 hours of tutoring credit</li>
              <li>$32 per hour (save $3/hour)</li>
              <li>Use with any counselor</li>
              <li>Credits never expire</li>
            </ul>
            <button 
              class="hero-submit bundle-button" 
              @click="buyBundle('5_hours')"
              :disabled="loading"
            >
              {{ purchasingBundle === '5_hours' ? 'Processing...' : 'Buy 5 Hour Bundle' }}
            </button>
          </div>

          <div class="pricing-card">
            <div class="card-header-strip bundle10-strip"></div>
            <h2>
              <div class="card-title">10 Hour Bundle</div>
              <div class="price">$300</div>
            </h2>
            <ul>
              <li>10 hours of tutoring credit</li>
              <li>$30 per hour (save $5/hour)</li>
              <li>Most popular option</li>
              <li>Priority booking support</li>
            </ul>
            <button 
              class="hero-submit bundle-button" 
              @click="buyBundle('10_hours')"
              :disabled="loading"
            >
              {{ purchasingBundle === '10_hours' ? 'Processing...' : 'Buy 10 Hour Bundle' }}
            </button>
          </div>

          <div class="pricing-card">
            <div class="card-header-strip bundle20-strip"></div>
            <h2>
              <div class="card-title">20 Hour Bundle</div>
              <div class="price">$560</div>
            </h2>
            <ul>
              <li>20 hours of tutoring credit</li>
              <li>$28 per hour (save $7/hour)</li>
              <li>Best value for serious students</li>
              <li>VIP support and scheduling</li>
            </ul>
            <button 
              class="hero-submit bundle-button" 
              @click="buyBundle('20_hours')"
              :disabled="loading"
            >
              {{ purchasingBundle === '20_hours' ? 'Processing...' : 'Buy 20 Hour Bundle' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from './../components/NavBar.vue';
import { redirectToCheckout } from '@/utils/stripe.js';
import Auth from '@/auth/auth.js';

export default {
  components: {
    NavBar
  },
  data() {
    return {
      loading: false,
      purchasingBundle: null, // Track which bundle is being purchased
    };
  },
  methods: {
    goToSignUp() {
      this.$router.push('/auth/sign-up');
    },
    
    async buyBundle(bundleType) {
      // Check if user is authenticated
      if (!Auth.isAuthenticated()) {
        alert('Please log in to purchase credits');
        this.$router.push('/auth/login');
        return;
      }

      console.log(`🛒 Attempting to buy ${bundleType} bundle...`);
      
      this.loading = true;
      this.purchasingBundle = bundleType;
      
      try {
        // Use your Stripe utility function
        await redirectToCheckout({
          session_type: 'credit_bundle',
          bundle_type: bundleType
        });
        
        console.log('✅ Redirecting to Stripe Checkout...');
        
      } catch (error) {
        console.error('❌ Checkout failed:', error);
        
        // Show user-friendly error message
        if (error.message.includes('placeholder')) {
          alert('Payment system is being set up. Please try again later!');
        } else {
          alert('Payment error: ' + error.message);
        }
        
      } finally {
        this.loading = false;
        this.purchasingBundle = null;
      }
    }
  }
};
</script>

<style scoped>
.how-it-works {
  display: flex;
  align-items: flex-start; /* don’t stretch everything */
  gap: 1rem;
  background-color: white;
  padding: 1rem 2rem 0rem 2rem;
}

.pricing-header {
  text-align: left;
  font-size: 1.8rem;
  font-weight: bold;
  color: #1d2a57;
  background-color: white;
  padding-top: 130px;
  padding-left: 50px;
}

.left-image {
  flex: 0 0 35%; /* only take 35% of the row */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  max-width: 50%; /* optional: keep image smaller than cards */
}

.left-image img {
  width: 100%;
  height: auto;
  max-height: 100%;   /* cap image to card height */
  object-fit: contain; /* scale proportionally, no cropping */
  border-radius: 12px;
}

.right-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  padding: 1rem;
  background-color: white;
}

.text-section {
  margin-bottom: 2.5rem;
}

.title {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.2rem;
  color: black;
  margin-bottom: 2rem;
}

.steps p {
  margin-bottom: 1.5rem;
  line-height: 1.8;
  font-size: 1.1rem;
  color: black;
}

.pricing-section {
  display: flex;
  gap: 2rem;
  align-items: stretch;
}

.pricing-card {
  flex: 1;
  min-width: 250px;
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  word-wrap: break-word; /* ensures no cutoff */
}

.card-header-strip {
  position: absolute;
  top: 0;
  left: 0;
  height: 12px;
  width: 100%;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.top50-strip {
  background-color: #64d2a6; /* greenish */
}

.ivy-strip {
  background-color: #1d2a57; /* dark blue */
}

.pricing-card h2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.card-title {
  font-size: 1.8rem;
  color: #222;
  font-weight: 600;
  margin-bottom: 1rem; /* <- space between title and price */
}

.price {
  color: #28a745;
  font-weight: bold;
  font-size: 1.8rem; 
}

.pricing-card ul {
  font-size: 1.1rem;
  line-height: 2;
  padding-left: 1.2rem;
  margin-bottom: 1.2rem;
  list-style-type: disc;
}

.pricing-card li {
  color: black;
}

.hero-submit {
  color: black;
  padding: 0.75rem 1.5rem;
  border: 1.5px solid black;
  border-radius: 6px;
  font-size: 1.2rem;
  cursor: pointer;
  display: block;
  width: fit-content;
  margin: 0 auto; /* center */
  text-align: center;
  text-decoration: none;
  transition: background-color 0.2s, color 0.2s;
}

.top-university-price-consult {
  background-color:rgb(188, 242, 221);
}

.ivy-league-price-consult {
  background-color:rgb(168, 182, 233);
}

.hero-submit:hover {
  color: black;
}

.top-university-price-consult:hover {
  background-color:rgb(68, 174, 132);
  color:white;
}

.ivy-league-price-consult:hover {
  background-color: #1d2a57;
  color: white;
}

.pricing-summary {
  background-color: white;
  padding: 0rem 2rem;
}

.pricing-summary-header {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.summary-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.summary-text h2 {
  font-size: 1.8rem;
  color: #1d2a57;
  font-weight: 600;
  margin-bottom: 1rem;
  line-height: 1.4;
}

.summary-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 1rem;
}

.summary-chart img {
  max-width: 200px;
  height: auto;
  object-fit: contain;
}

.pricing-summary-features {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: white;
  padding-bottom: 5rem;
}

.feature-card {
  flex: 1;
  min-width: 250px;
  text-align: center;
}

.feature-card img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 1rem;
}

.feature-card h3 {
  font-size: 1.2rem;
  color: #1d2a57;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.feature-card p {
  color: #555;
  font-size: 1.2rem;
  line-height: 1.6;
  padding-left: 2rem;
  padding-right: 2rem;
}

.pricing-view-container {
  min-height: 100vh;
  background-color: white;
}


/* Responsive stack */
@media (max-width: 900px) {
  .how-it-works {
    flex-direction: column;
    height: auto;
  }

  .left-image {
    order: -1;  /* put image above cards */
    max-width: 100%; /* take full width */
  }

  .left-image img {
    width: 100%;
    height: auto;
    max-height: none; /* reset so it doesn’t squash */
    object-fit: contain;
  }
}

/* NEW STYLES FOR CREDIT BUNDLES SECTION */
.credit-bundles-section {
  background-color: white; /* Changed from #f8f9fa to white */
  padding: 3rem 0;
}

.bundles-header {
  text-align: center;
  font-size: 1.8rem;
  font-weight: bold;
  color: #1d2a57;
  background-color: white;
  padding: 1rem 0 0 0; /* Reduced from 2rem to 1rem */
  margin-bottom: 2rem;
}

.bundles-full-content {
  width: 100%;
  padding: 2rem;
  background-color: white; /* Changed from #f8f9fa to white */
}

.bundles-full-content .pricing-section {
  background-color: white; /* Changed from #f8f9fa to white */
  gap: 2rem;
  justify-content: center;
}

.bundles-full-content .pricing-section {
  background-color: #f8f9fa;
  gap: 2rem; /* Full spacing for 3 cards */
  justify-content: center;
}

/* New strip colors for bundles */
.bundle5-strip {
  background-color: #ffc107; /* yellow/gold */
}

.bundle10-strip {
  background-color: #fd7e14; /* orange */
}

.bundle20-strip {
  background-color: #dc3545; /* red */
}

/* Bundle button styling */
.bundle-button {
  background-color: #007bff !important;
  color: white !important;
  border: 1.5px solid #007bff !important;
}

.bundle-button:hover {
  background-color: #0056b3 !important;
  color: white !important;
}
</style>